<page-heading
  [title]="'agents.openai.pageTitle' | translate"
  [description]="'agents.openai.pageDescription' | translate"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-9 input-trend-search">
            <input
              type="search"
              #searchBox
              class="form-control"
              [placeholder]="'agents.openai.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)"
            />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
            <button class="btn btn-info fw-bold" (click)="createIntegration()">
              {{ 'agents.openai.addIntegrationButton' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  @if (pager.total === 0 && !loadingContent) {
  <empty-records-component
    [icon]="'ri-robot-2-line'"
    [labelButton]="'agents.openai.addButton' | translate"
    [subMessage]="'agents.openai.emptySubMessage' | translate"
    [message]="'agents.openai.emptyMessage' | translate"
    (emitEvent)="createIntegration()"
  />
  } @else if (!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'agents.openai.columnCreatedAt' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'agents.openai.columnIntegrationName' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'agents.openai.columnStatus' | translate }}</th>
          <th>
            <span class="sr-only"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (integration of pager.list; track $index) {
        <tr>
          <td>
            <span>
              {{
                integration.createdAt
                  | timezoneDate
                    : "DD/MM/YYYY"
                    : getTimezoneCompanyCurrentUser()
              }}
            </span>
          </td>
          <td>
            <strong class="text-truncate">{{ integration.name }}</strong>
          </td>
          <td>
            @if (health(integration)) {
            <span class="badge bg-danger" [title]="health(integration)?.lastError ?? ''">
              {{ healthLabelKey(integration) | translate }}
            </span>
            } @else {
            <span class="badge" [ngClass]="integration.actived ? 'bg-success' : 'bg-warning'">
              {{ integration.actived ? ('agents.openai.statusActive' | translate) : ('agents.openai.statusInactive' | translate) }}
            </span>
            }
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-dropdown-list"
                [matMenuTriggerFor]="menu"
                type="button"
              >
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="openAssistants(integration)"
                >
                  {{ 'agents.openai.menuAssistants' | translate }}
                </button>
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="edit(integration)"
                >
                  {{ 'agents.openai.menuEdit' | translate }}
                </button>
                @if (health(integration)) {
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="reactivate(integration)"
                >
                  {{ 'agents.openai.reactivate' | translate }}
                </button>
                }
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="delete(integration)"
                >
                  {{ 'agents.openai.menuDelete' | translate }}
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>

    @if (pager.total > pager.perPage) {
    <paginator
      class="flex justify-content-center mt-3 mb-3"
      [pager]="pager"
      (onPager)="loadPage($event)"
    />
    }
  </div>
  }
</div>